import { Functions, httpsCallable, HttpsCallable } from 'firebase/functions'
import type {
  CompanySearchResults,
  SearchCompaniesReq,
  CompanyDetailsReq,
  CompanyDetailsResponse,
  ClaimCompanyReq,
  ClaimCompanyResponse,
  CreateInvitationReq,
  CreateInvitationResponse,
  AcceptInvitationReq,
  MyInvitationsResponse,
  SignDocumentReq,
  SignDocumentResponse,
} from './functions.types'

let searchCompanies: HttpsCallable<SearchCompaniesReq, CompanySearchResults>
let companyDetails: HttpsCallable<CompanyDetailsReq, CompanyDetailsResponse>
let claimCompany: HttpsCallable<ClaimCompanyReq, ClaimCompanyResponse>
let createInvitation: HttpsCallable<
  CreateInvitationReq,
  CreateInvitationResponse
>
let acceptInvitation: HttpsCallable<AcceptInvitationReq, void>
let myInvitations: HttpsCallable<void, MyInvitationsResponse>
let signDocument: HttpsCallable<SignDocumentReq, SignDocumentResponse>

export const initialiseFunctions = (functions: Functions) => {
  searchCompanies = httpsCallable(functions, 'searchCompanies', {
    timeout: 20000,
  })
  companyDetails = httpsCallable(functions, 'companyDetails', {
    timeout: 10000,
  })
  claimCompany = httpsCallable(functions, 'claimCompany', {
    timeout: 20000,
  })
  createInvitation = httpsCallable(functions, 'createInvitation', {
    timeout: 20000,
  })
  acceptInvitation = httpsCallable(functions, 'acceptInvitation', {
    timeout: 20000,
  })
  myInvitations = httpsCallable(functions, 'myInvitations', {
    timeout: 10000,
  })
  signDocument = httpsCallable(functions, 'signDocument', {
    timeout: 20000,
  })
}

export const onSearchCompanies = (data: SearchCompaniesReq) => {
  return searchCompanies(data)
}

export const onCompanyDetails = (data: CompanyDetailsReq) => {
  return companyDetails(data)
}

export const onClaimCompany = (data: ClaimCompanyReq) => {
  return claimCompany(data)
}

export const onCreateInvitation = (data: CreateInvitationReq) => {
  return createInvitation(data)
}

export const onAcceptInvitation = (data: AcceptInvitationReq) => {
  return acceptInvitation(data)
}

export const onMyInvitations = () => {
  return myInvitations()
}

export const onSignDocument = (data: SignDocumentReq) => {
  return signDocument(data)
}
